import { render, staticRenderFns } from "./AckTermsButton.vue?vue&type=template&id=fa992a4c&scoped=true"
import script from "./AckTermsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AckTermsButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AckTermsButton.vue?vue&type=style&index=0&id=fa992a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_babel-core@6.26.3_supports-color@7.2.0__css_4ebb8a9bdd1166ae2f68e8a453c2f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa992a4c",
  null
  
)

export default component.exports